import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  width: 17px;
  height: 3px;
`

export const DotsIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg viewBox="0 0 17 3" fill="none" className={className}>
      <path d="M1.41281 2.75C1.06805 2.75 0.774143 2.62724 0.531087 2.38172C0.288032 2.13621 0.166504 1.84108 0.166504 1.4963C0.166504 1.15154 0.289264 0.857639 0.534785 0.614583C0.780289 0.371528 1.07543 0.25 1.4202 0.25C1.76496 0.25 2.05886 0.372761 2.30192 0.618282C2.54498 0.863785 2.6665 1.15892 2.6665 1.5037C2.6665 1.84846 2.54374 2.14236 2.29822 2.38542C2.05272 2.62847 1.75758 2.75 1.41281 2.75ZM8.49614 2.75C8.15138 2.75 7.85748 2.62724 7.61442 2.38172C7.37137 2.13621 7.24984 1.84108 7.24984 1.4963C7.24984 1.15154 7.3726 0.857639 7.61812 0.614583C7.86362 0.371528 8.15876 0.25 8.50354 0.25C8.84829 0.25 9.1422 0.372761 9.38525 0.618282C9.62831 0.863785 9.74984 1.15892 9.74984 1.5037C9.74984 1.84846 9.62708 2.14236 9.38155 2.38542C9.13605 2.62847 8.84091 2.75 8.49614 2.75ZM15.5795 2.75C15.2347 2.75 14.9408 2.62724 14.6978 2.38172C14.4547 2.13621 14.3332 1.84108 14.3332 1.4963C14.3332 1.15154 14.4559 0.857639 14.7015 0.614583C14.947 0.371528 15.2421 0.25 15.5869 0.25C15.9316 0.25 16.2255 0.372761 16.4686 0.618282C16.7116 0.863785 16.8332 1.15892 16.8332 1.5037C16.8332 1.84846 16.7104 2.14236 16.4649 2.38542C16.2194 2.62847 15.9242 2.75 15.5795 2.75Z" />
    </Svg>
  )
}
